import type { ApplicationStatus } from '../fixtures/domain.js';
import { badgeStyle, statusBadgeOf } from './stageMeta.js';
import styles from './StatusTag.module.css';

/** A stage as a small, text-only tag. Nothing at pending unless the chat has ended. */
export function StatusTag({
  status,
  ended,
  className,
}: {
  status: ApplicationStatus;
  ended?: boolean;
  className?: string;
}) {
  const badge = statusBadgeOf(status);
  const cls = (base: string | undefined) => (className ? `${base} ${className}` : base);
  if (badge) {
    return (
      <span className={cls(styles.tag)} style={badgeStyle(badge.token)}>
        {badge.label}
      </span>
    );
  }
  return ended ? <span className={cls(styles.neutral)}>Chat ended</span> : null;
}
